<template>
  <main
    data-page-id="accessibility-statement-page"
    class="accessibility-page"
  >
    <div class="container">
      <h1>Proxify's Accessibility Statement</h1>

      <div>
        <div>
          <h2>Accessibility statement</h2>
          <div class="content">
            <p>
              This accessibility statement applies to content published on
              <a href="https://proxify.io">https://proxify.io</a>
            </p>
            <p>
              Proxify is committed to ensuring the accessibility of its website
              and digital services in accordance with applicable accessibility
              laws and standards, including:
            </p>
            <ul>
              <li>
                The
                <strong>European Accessibility Act</strong>
                (Directive (EU) 2019/882)
              </li>
              <li>
                The
                <strong>Swedish Discrimination Act</strong>
                (2008:567)
              </li>
              <li>
                The
                <strong>Americans with Disabilities Act</strong>
                (ADA)
              </li>
            </ul>
            <br />
            <p>
              We aim to conform to the
              <strong>Web Content Accessibility Guidelines (WCAG) 2.1</strong>
              , Level AA, and the European standard
              <strong>EN 301 549 v.3.2.1</strong>
              .
            </p>
          </div>
        </div>
        <div>
          <h2>Feedback and contact</h2>
          <div>
            <p>
              If you experience any accessibility issues, please contact us:
            </p>
            <p>Email: legal@proxify.io</p>
            <p>Please include the page URL and a description of the problem.</p>
          </div>
        </div>
        <div>
          <h2>Compatibility with assistive technology</h2>
          <p>
            The Proxify website is designed to be compatible with screen
            readers, speech recognition software, and browsers with
            keyboard-only navigation.
          </p>
          <div>
            <h2>Preparation of this statement</h2>
            <p>
              This statement was prepared and last reviewed on Wednesday, April
              16, 2025.
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import './AccessibilityStatementPage.scss';
</style>
